import { Heart } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface FavoriteButtonProps {
  isFavorite: boolean;
  onToggle: () => void;
  className?: string;
  size?: number;
}

const FavoriteButton = ({ isFavorite, onToggle, className, size = 20 }: FavoriteButtonProps) => {
  const [animating, setAnimating] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setAnimating(true);
    onToggle();
    setTimeout(() => setAnimating(false), 400);
  };

  return (
    <button
      onClick={handleClick}
      aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
      className={cn(
        "group/fav inline-flex items-center justify-center rounded-full transition-all duration-300",
        "bg-background/80 backdrop-blur-sm border border-border shadow-sm",
        "hover:shadow-md hover:scale-110",
        "w-9 h-9",
        className
      )}
    >
      <Heart
        size={size}
        aria-hidden="true"
        focusable="false"
        className={cn(
          "transition-all duration-300",
          isFavorite
            ? "fill-red-500 text-red-500"
            : "fill-transparent text-muted-foreground group-hover/fav:text-red-400",
          animating && "animate-[heartbeat_0.4s_ease-in-out]"
        )}
      />
    </button>
  );
};

export default FavoriteButton;
